<template>
  <f7-page>
    <f7-navbar :no-shadow="true">
      <f7-nav-left
        color-theme="white"
        back-link="返回">
      </f7-nav-left>
      <f7-nav-title>施工日志</f7-nav-title>
      <f7-nav-right>
        <f7-link
          @click="editable = !editable"
          v-show="!editable && today === project.date">
          编辑
        </f7-link>
        <f7-link @click="add" v-show="editable">保存</f7-link>
      </f7-nav-right>
    </f7-navbar>
    <div class="has-content">
      <div class="list">
        <div class="item-content item-input">
          <div class="item-inner" style="display: flex; align-items: center;">
            <div class="item-input-wrap" style="padding-left: 1rem;">
              <input
                type="text"
                placeholder="请选择日期"
                readonly="readonly"
                id="calendar-logDate"
                style="text-align: left;"/>
            </div>
            <f7-link @click="openCal">
              <div class="item-after">
                <f7-icon fa="angle-right"></f7-icon>
              </div>
            </f7-link>
          </div>
        </div>
        <div class="item-content item-input">
          <div class="item-inner" style="display: flex; align-items: center;">
            <f7-link @click="projectPopupOpened = true" style="width: 100%;">
              <div class="item-input-wrap" style="padding-left: 1rem; width: 95%;">
                {{ project.name }}
              </div>
            </f7-link>
              <div class="item-after">
                <f7-icon fa="angle-right"></f7-icon>
              </div>
          </div>
        </div>
      </div>
      <div style="display: flex; text-align: right; padding-top: 0.5rem;" v-show="editable">
        <div style="flex: auto;">
        </div>
        <div style="width: 5rem;">
          <f7-button @click="sendGroup">发送到群</f7-button>
        </div>
      </div>
      <div v-show="!editable">
        <log-view :work-log="workLog" :weather="weather"></log-view>
      </div>
      <div v-show="editable && today === project.date">
        <div class="weather">
        <div class="weather-item">
          <div class="weather-item-label">
            天气
          </div>
          <div class="weather-item-line">
            <div class="weather-item-content">
              {{ (workLog.weather && workLog.weather !== '') ?
                workLog.weather : weather.weather }}
            </div>
          </div>
        </div>
        <div class="weather-item">
          <div class="weather-item-label">
            温度
          </div>
          <div class="weather-item-line">
            <div class="weather-item-content">
              {{ (workLog.temperature && workLog.temperature !== '') ?
                workLog.temperature : weather.temperature }}
            </div>
          </div>
        </div>
        <div class="weather-item">
          <div class="weather-item-label">
            风力
          </div>
          <div class="weather-item-line" style="border-right: none;">
            <div class="weather-item-content">
              <span v-show="workLog.windDirection || weather.windDirection">
                {{ (workLog.windDirection && workLog.windDirection !== '') ?
                  workLog.windDirection : weather.windDirection }} 风
              </span>
              <span v-show="workLog.windPower || weather.windPower">
                {{ (workLog.windPower && workLog.windPower !== '') ?
                  workLog.windPower : weather.windPower }} 级
              </span>
            </div>
          </div>
        </div>
      </div>
        <div>
          <div class="textarea-label">
            <div class="textarea-label-text">
              工作安排
            </div>
            <div>
              <f7-checkbox name="jobPlan"
                :checked="jobPlanFlag"
                @change="jobPlanFlag = !jobPlanFlag">
              </f7-checkbox>
            </div>
            <div class="textarea-label-tip">
              是否发送到群
            </div>
          </div>
          <div class="textarea-item">
            <f7-list inline-labels id="jobPlanForm">
              <f7-list-input
                type="textarea"
                :value="workLog.jobPlan"
                @input="workLog.jobPlan = $event.target.value"
                placeholder="请填写工作安排"
                required
                validate
                minlength=2
                maxlength=500
                error-message="必填项，2-500个字符"
                inputStyle="transform: translateZ(0); text-align: left; padding-top: 0rem;"
                style="width: 100%; height: 100%;"
                resizable>
              </f7-list-input>
            </f7-list>
          </div>
        </div>
        <div>
          <div class="textarea-label">
            <div class="textarea-label-text">
              事项记录
            </div>
            <div>
              <f7-checkbox name="itemRecord"
                :checked="itemRecordFlag"
                @change="itemRecordFlag = !itemRecordFlag">
              </f7-checkbox>
            </div>
            <div class="textarea-label-tip">
              是否发送到群
            </div>
          </div>
          <div class="textarea-item">
            <f7-list inline-labels id="itemRecordForm">
              <f7-list-input
                type="textarea"
                :value="workLog.itemRecord"
                @input="workLog.itemRecord = $event.target.value"
                placeholder="请填写事项记录"
                inputStyle="transform: translateZ(0); text-align: left; padding-top: 0rem;"
                style="width: 100%; height: 100%;"
                validate
                maxlength=500
                error-message="必填项，0-500个字符"
                resizable>
              </f7-list-input>
            </f7-list>
          </div>
        </div>
        <div>
          <div class="textarea-label">
            <div class="textarea-label-text">
              技术、质量、安全要求
            </div>
            <div>
              <f7-checkbox name="temRequire"
                :checked="itemRequireFlag"
                @change="itemRequireFlag = !itemRequireFlag">
              </f7-checkbox>
            </div>
            <div class="textarea-label-tip">
              是否发送到群
            </div>
          </div>
          <div class="textarea-item">
            <f7-list inline-labels id="itemRequireForm">
              <f7-list-input
                type="textarea"
                :value="workLog.itemRequire"
                @input="workLog.itemRequire = $event.target.value"
                placeholder="请填写技术、质量、安全要求"
                required
                validate
                minlength=2
                maxlength=500
                error-message="必填项，2-500个字符"
                inputStyle="transform: translateZ(0); text-align: left; padding-top: 0rem;"
                style="width: 100%; height: 100%;"
                resizable>
              </f7-list-input>
            </f7-list>
          </div>
        </div>
      </div>
      <div class="img-show-area">
        <div class="img-show" v-for="item in workLog.attachIds" :key="item">
          <img
            :src="`${imageUrl}?attachmentId=${item}`"
            width="100%"
            height="100%"
            v-if="editable" />
          <img
            :src="`${imageUrl}?attachmentId=${item}`"
            width="100%"
            height="100%"
            @click="browserPhoto(workLog.attachIds)" v-if="!editable" />
          <div class="img-show-close" @click="removeOldFile(item)" v-if="editable">
            <f7-icon fa="times" size="1rem"></f7-icon>
          </div>
        </div>
        <div class="img-show" v-for="file in files" :key="file.id">
          <img v-if="file.thumb" :src="file.thumb" width="100%" height="100%" />
          <span v-else>无图片</span>
          <div class="img-show-close" @click="removeFile(file)">
            <f7-icon fa="times" size="1rem"></f7-icon>
          </div>
        </div>
        <div class="img-show" v-if="editable">
          <file-upload
            class="file-upload"
            input-id="workLogFile"
            :post-action="uploadURL"
            :extensions="extensions"
            :accept="accept"
            :multiple="multiple"
            :size="size || 0"
            :thread="thread < 1 ? 1 : (thread > 5 ? 5 : thread)"
            :add-index="addIndex"
            v-model="files"
            @input-filter="inputFilter"
            ref="workLogUpload">
            <f7-icon fa="plus" size="1rem"></f7-icon>
          </file-upload>
        </div>
        <div class="img-show" v-else></div>
        <div
          class="img-show"
          v-if="(workLog.attachIds.length + files.length + 1) % 3 > 0
            && (workLog.attachIds.length + files.length + 1) % 3 <= 1">
        </div>
        <div
          class="img-show"
          v-if="(workLog.attachIds.length + files.length + 1) % 3 > 0
            && (workLog.attachIds.length + files.length + 1) % 3 <= 2">
        </div>
      </div>
    </div>
    <f7-popup :opened="projectPopupOpened" @popup:closed="projectPopupOpened = false">
      <log-project-list
        :opened="projectPopupOpened"
        :project.sync="project"
        :independent="false">
      </log-project-list>
    </f7-popup>
  </f7-page>
</template>
<script>
import lodash from 'lodash';
import { toWorkLog, getLocation } from '@/util/native';
import FileUpload from 'vue-upload-component';
import { imageView, uploadFileUrl } from '@/api/common';
import { createCalendar, createToast } from '@/util/compUtils';
import { dateFormat, parseDate } from '@/util/dateUtils';
import { WorkLog } from '@/model/reqObject';
import { getWorkDayList, getWeather, getWorkLog, saveWorkLog } from '@/api/workLog';
import LogProjectList from '@/components/LogProjectList';
import LogView from './logView';

export default {
  props: ['projectId'],
  components: {
    LogProjectList,
    LogView,
    FileUpload,
  },
  data() {
    return {
      today: dateFormat(new Date()),
      projectPopupOpened: false,
      weather: {},
      jobPlanFlag: false,
      itemRecordFlag: false,
      itemRequireFlag: false,
      project: {
        id: this.projectId,
        name: this.$f7route.query.name,
        date: dateFormat(new Date()),
      },
      editable: false,
      workLog: new WorkLog({ createTime: dateFormat(new Date()) }),
      calComp: null,
      imageUrl: imageView,
      files: [],
      accept: 'image/png,image/gif,image/jpeg,image/webp',
      extensions: 'gif,jpg,jpeg,png,webp',
      minSize: 1024,
      size: 1024 * 1024 * 10,
      multiple: true,
      addIndex: false,
      thread: 3,
      name: 'file',
      uploadURL: uploadFileUrl,
      flag: true,
    };
  },
  created() {
    window.setLocation = this.setLocation;
  },
  watch: {
    'project.id': {
      handler: function idChg(val, oldVal) {
        if (!lodash.isEmpty(val) && val !== oldVal) {
          this.init();
          this.getWeatherInfo();
          this.getInfo();
          this.editable = false;
          this.files = [];
        }
      },
      deep: true,
    },
    'project.date': {
      handler: function idChg(val, oldVal) {
        if (!lodash.isEmpty(val) && val !== oldVal) {
          this.init();
          this.getWeatherInfo();
          this.getInfo();
          this.editable = false;
          this.files = [];
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.init();
    this.getWeatherInfo();
    this.getInfo();
    this.$watch(
      () => this.flag && this.files.length !== 0
        && this.$refs.workLogUpload && this.$refs.workLogUpload.uploaded,
      (newVal) => {
        if (newVal) {
          this.addObj();
        }
      },
    );
  },
  methods: {
    init() {
      const params = {
        projectId: this.project.id || this.projectId,
        date: this.workLog.createTime || this.project.date,
      };
      getWorkDayList(params).then((result) => {
        let events = [];
        if (result.code === 0) {
          events = (result.data || []).map((item) => {
            const dt = parseDate(item);
            return ({
              date: new Date(dt.getFullYear(), dt.getMonth(), dt.getDate()),
            });
          });
        }
        if (this.calComp) {
          this.calComp.destroy();
        }
        this.calComp = createCalendar(this, '#calendar-logDate', 'project', 'date', events);
      });
    },
    openCal() {
      this.calComp.open();
    },
    sendGroup() {
      if (!(this.jobPlanFlag || this.itemRecordFlag || this.itemRequireFlag)) {
        createToast(this, '没有选择发送的内容');
        return;
      }
      const msg = Object.assign({}, {
        date: this.project.date,
        name: this.project.name,
        projectId: this.project.id || this.projectId,
        weather: this.weather.weather,
        temperature: this.weather.temperature,
        windPower: this.weather.windPower,
        windDirection: this.weather.windDirection,
      });
      let valided = true;
      if (this.jobPlanFlag) {
        // this.$f7.input.validateInputs('#jobPlanForm');
        this.$$('#jobPlanForm').find('input, textarea, select').forEach((inputEl) => {
          valided = valided && !this.$$(inputEl).hasClass('input-invalid');
        });
        if (!valided) {
          createToast(this, '请填写工作安排');
        } else {
          this.$set(msg, 'jobPlan', this.workLog.jobPlan);
        }
      }
      if (this.itemRecordFlag) {
        // this.$f7.input.validateInputs('#itemRecordForm');
        this.$$('#itemRecordForm').find('input, textarea, select').forEach((inputEl) => {
          valided = valided && !this.$$(inputEl).hasClass('input-invalid');
        });
        if (!valided || lodash.isEmpty(this.workLog.itemRecord)) {
          createToast(this, '请填写事项记录');
        } else {
          this.$set(msg, 'itemRecord', this.workLog.itemRecord);
        }
      }
      if (this.itemRequireFlag) {
        // this.$f7.input.validateInputs('#itemRequireForm');
        this.$$('#itemRequireForm').find('input, textarea, select').forEach((inputEl) => {
          valided = valided && !this.$$(inputEl).hasClass('input-invalid');
        });
        if (!valided) {
          createToast(this, '请填写技术、质量、安全要求');
        } else {
          this.$set(msg, 'itemRequire', this.workLog.itemRequire);
        }
      }
      if (!valided) {
        return;
      }
      toWorkLog(
        this.project.id || this.projectId,
        JSON.stringify(msg));
    },
    getWeatherInfo() {
      const params = getLocation();
      this.setLocation(params.latitude, params.longitude);
    },
    setLocation(lat, lag) {
      const params = { latitude: lat, longitude: lag };
      getWeather(params).then((result) => {
        if (result.code === 0) {
          this.weather = result.data || {};
        }
      });
    },
    getInfo() {
      const params = { projectId: this.project.id, date: this.project.date };
      getWorkLog(params).then((result) => {
        if (result.code === 0) {
          this.workLog = new WorkLog(result.data || {});
          this.$set(this.workLog, 'createTime', dateFormat(this.workLog.createTime));
        }
      });
    },
    add() {
      this.flag = false;
      let valided = true;
      // this.$f7.input.validateInputs('#jobPlanForm');
      this.$$('#jobPlanForm').find('input, textarea, select').forEach((inputEl) => {
        valided = valided && !this.$$(inputEl).hasClass('input-invalid');
      });
      // this.$f7.input.validateInputs('#itemRecordForm');
      this.$$('#itemRecordForm').find('input, textarea, select').forEach((inputEl) => {
        valided = valided && !this.$$(inputEl).hasClass('input-invalid');
      });
      // this.$f7.input.validateInputs('#itemRequireForm');
      this.$$('#itemRequireForm').find('input, textarea, select').forEach((inputEl) => {
        valided = valided && !this.$$(inputEl).hasClass('input-invalid');
      });
      if (valided &&
        (this.files.length === 0
          || (this.$refs.workLogUpload && this.$refs.workLogUpload.uploaded))) {
        this.addObj();
      } else if (valided && this.files.length > 0) {
        this.$f7.dialog.preloader('正在上传数据');
        this.$refs.workLogUpload.active = true;
        this.flag = true;
      }
    },
    addObj() {
      let uploadValid = true;
      const fileIdList = this.workLog.attachIds || [];
      this.files.forEach((file) => {
        uploadValid = uploadValid && (file.response.code === 0);
        if (file.response.code === 0) {
          fileIdList.push(file.response.data.id);
        }
      });
      if (uploadValid) {
        this.files = [];
        this.$set(this.workLog, 'attachIds', lodash.uniq(fileIdList));
        this.$set(this.workLog, 'projectId', this.project.id || this.projectId);
        this.$set(this.workLog, 'weather', this.weather.weather);
        this.$set(this.workLog, 'temperature', this.weather.temperature);
        this.$set(this.workLog, 'windPower', this.weather.windPower);
        this.$set(this.workLog, 'windDirection', this.weather.windDirection);
        saveWorkLog(this.workLog).then((result) => {
          this.editable = false;
          this.$f7.dialog.close();
          if (result.code === 0) {
            createToast(this, '保存成功');
          }
        });
      }
    },
    browserPhoto(itemArr) {
      this.$f7.photoBrowser.create({
        photos: (itemArr || []).map(item => `${this.imageUrl}?attachmentId=${item}`),
        backLinkText: '返回',
        navbarOfText: '/',
        iconsColor: 'white',
        routableModals: false,
      }).open();
    },
    removeFile(oldFile) {
      if (this.files.includes(oldFile)) {
        this.files.splice(this.files.findIndex(item => item.id === oldFile.id), 1);
      }
    },
    removeOldFile(id) {
      if (this.workLog.attachIds.includes(id)) {
        this.workLog.attachIds.splice(
          this.workLog.attachIds.findIndex(item => item === id), 1);
      }
    },
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        if (!/\.(jpeg|jpe|jpg|gif|png|webp)$/i.test(newFile.name)) {
          return prevent();
        }
      }
      if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
        Object.assign(newFile, { blob: '' });
        const URL = window.URL || window.webkitURL;
        if (URL && URL.createObjectURL) {
          Object.assign(newFile, { blob: URL.createObjectURL(newFile.file) });
        }
        Object.assign(newFile, { thumb: '' });
        if (newFile.blob && newFile.type.substr(0, 6) === 'image/') {
          Object.assign(newFile, { thumb: newFile.blob });
        }
      }
      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/style/app-var.scss';

  .weather {
    margin: 0.5rem 0rem;
    padding: 0.5rem 0rem;
    height: 4rem;
    background-color: $panel-bg-color;
    border-radius: 0.3rem;
    display: flex;
  }

  .weather-item {
    position: relative;
    height: 100%;
    text-align: center;
    width: 33.33333333%;
  }

  .weather-item-label {
    position: absolute;
    left: 0.5rem;
    top: 0rem;
    color: $second-font-color;
    font-size: 0.8rem;
  }

  .weather-item-line {
    border-right: 0.05rem solid $border-color;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .weather-item-content {
    padding-top: 0.5rem;
  }

  .textarea-label {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .textarea-label-text {
    flex: auto;
    padding-left: 1rem;
    font-size: 1rem;
    min-height: 2rem;
    // height: 2rem;
    line-height: 2rem;
  }

  .textarea-label-tip {
    font-size: 0.8rem;
    color: $second-font-color;
  }

  .textarea-item {
    margin: 0rem 0rem;
    padding: 0rem 0.5rem;
    border: 0.05rem solid $border-color;
    border-radius: 0.3rem;
  }

  .img-show-area {
    border-top: 0.05rem solid $border-color;
    text-align: center;
    padding: 1rem 0rem;
    display: flex;
    flex-flow:row wrap;
    align-items: flex-start;
    justify-content: space-around;
  }

  .img-show {
    width: 30%;
    height: 6rem;
    padding: 0.5rem 0rem;
    position: relative;
  }

  .img-show-close {
    color: $white-color;
    height: 1rem;
    width: 1rem;
    line-height: 1rem;
    position: absolute;
    right: 0rem;
    top: 0.5rem;
    text-align: center;
    background-color: $theme-color;
    cursor: pointer;
  }

  .file-upload {
    background-color: $panel-bg-color;
    border-radius: 0.5rem;
    width: 100%;
    height: 100%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/pages/workLog/log.vue